/**
 * Application Configuration
 * This file can be safely committed to source control.
 * Actual secret values are stored in Azure App Configuration.
 */

// Azure App Configuration settings
export const AZURE_CONFIG = {
  // Connection string comes from environment variable (not committed)
  connectionString: process.env.REACT_APP_AZURE_CONFIG_CONNECTION_STRING,

  // Environment label for Azure App Configuration
  // This allows different configs for dev, staging, prod
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',

  // Endpoint (alternative to connection string for Managed Identity)
  endpoint: process.env.REACT_APP_AZURE_CONFIG_ENDPOINT,
};

// Configuration keys to fetch from Azure App Configuration
// These key names are safe to commit - they don't contain secrets
export const CONFIG_KEYS = {
  PUBNUB_PUBLISH_KEY: 'PubNub:PublishKey',
  PUBNUB_SUBSCRIBE_KEY: 'PubNub:SubscribeKey',
  PUBNUB_CHANNEL: 'PubNub:Channel',
};

// Default/fallback values for local development when Azure is not configured
// Only used when Azure App Configuration is unavailable
export const FALLBACK_CONFIG = {
  [CONFIG_KEYS.PUBNUB_PUBLISH_KEY]: 'pub-c-95af62e0-34a5-4db8-a6ff-34d34905af18',
  [CONFIG_KEYS.PUBNUB_SUBSCRIBE_KEY]: 'sub-c-e09e6996-a30a-4999-bd28-1130ed58c9a8',
  [CONFIG_KEYS.PUBNUB_CHANNEL]: 'checkbox-demo-channel',
};

// Feature flags (can be overridden in Azure App Configuration)
export const FEATURES = {
  USE_AZURE_CONFIG: true,
  ENABLE_CONFIG_CACHING: true,
  LOG_CONFIG_LOADING: process.env.NODE_ENV === 'development',
};
